<template>
  <AuthForm
    v-model="formData"
    title="Sign in"
    description="Enter your email and password to sign in"
    :rules="rules"
    @submit="handleSubmit"
  >
    <div class="form-row mb-20px">
      <ElFormItem prop="email" class="full-width">
        <AppInput
          v-model="formData.email"
          label="Email"
          placeholder="Enter email address"
          validate-event
          type="email"
          :required="true"
        />
      </ElFormItem>
    </div>

    <div class="form-row mb-20px">
      <ElFormItem prop="password" class="full-width">
        <AppInput
          v-model="formData.password"
          label="Password"
          placeholder="Enter password"
          validate-event
          type="password"
          :required="true"
        />
      </ElFormItem>
    </div>

    <template #footer>
      <div class="d--f jc--sb full-width mt-20px">
        <div>New here? <router-link :to="{ name: 'register' }" class="router-link-plain">Sign up</router-link></div>

        <div><router-link :to="{ name: 'forgot-password' }" class="router-link-plain">Reset password</router-link></div>
      </div>
    </template>
  </AuthForm>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import { ElFormItem } from "element-plus";
import { AppInput } from "@/components/ui";

import AuthApi from "@/api/auth";
import AuthForm from "@/views/Auth/components/AuthForm.vue";
import { showToast } from "@/utilities/toast";

const router = useRouter();

const formData = reactive({
  email: "",
  password: "",
});

const rules = {
  email: [
    { required: true, message: "Please enter an email address", trigger: "blur" },
    { type: "email", message: "Please enter a valid email address", trigger: "blur" },
  ],
  password: [
    { required: true, message: "Please enter a password", trigger: "blur" },
    { min: 8, message: "Password must be at least 8 characters long", trigger: "blur" },
  ],
};

const handleSubmit = async () => {
  const response = await AuthApi.login(formData.email, formData.password);

  if (response.data.error) {
    showToast(response.data.error);
  } else {
    router.push("/");
  }
};
</script>
